import { SaveButton } from "components/Buttons"
import Table from "components/Table"
import React, { useState } from "react"
import { connect } from "react-redux"
import { Col, Row } from "reactstrap"
import { getPlacesWithChapters } from "store/actions"
import placesWithChaptersListColumns from "./placesWithChaptersListColumns"
import Select from "react-select"

const PlacesWithChaptersTab = ({
  placesWithChapters,
  chapters,
  getPlacesWithChapters,
  vendorId,
}) => {
  const [searchValue, setSearchValue] = useState("")
  const [showResetButton, setShowResetButton] = useState(false)
  const [defaultOrder, setDefaultOrder] = useState({
    o: "name",
    od: "asc",
  })

  const handleSearch = () => {
    if (searchValue?.length) {
      getPlacesWithChapters({
        ...defaultOrder,
        page: 1,
        per_page: 25,
        vendor_id: vendorId,
        chapter_ids: searchValue?.map(chapter => chapter?.value),
      })
      setShowResetButton(true)
    }
  }

  const handleResetSearch = () => {
    getPlacesWithChapters({
      ...defaultOrder,
      page: 1,
      per_page: 25,
      vendor_id: vendorId,
    })
    setSearchValue(null)
    setShowResetButton(false)
  }

  const handlePageChange = page => {
    getPlacesWithChapters({
      page: page,
      ...defaultOrder,
      per_page: 25,
      vendor_id: vendorId,
      ...(searchValue?.length
        ? { chapter_ids: searchValue?.map(chapter => chapter?.value) }
        : {}),
    })
  }

  const handleSort = (type, { sortField, sortOrder }) => {
    getPlacesWithChapters({
      o: sortField,
      od: sortOrder,
      page: 1,
      per_page: 25,
      vendor_id: vendorId,
      ...(searchValue?.length
        ? { chapter_ids: searchValue?.map(chapter => chapter?.value) }
        : {}),
    })
    setDefaultOrder({ o: sortField, od: sortOrder })
  }

  return (
    <React.Fragment>
      <Row className="my-3 ms-1 d-flex justify-content-end">
        <Col xs="auto">
          <SaveButton type="button" content="Download Filtered by Chapter" />
        </Col>
      </Row>
      <Row className="my-3 d-flex justify-content-center">
        <Col xs="auto">
          <div style={{ width: "500px" }}>
            <Select
              value={searchValue}
              onChange={selectedOption => {
                setSearchValue(selectedOption)
              }}
              isMulti
              name="chapters"
              options={chapters?.map(chapter => ({
                label: chapter?.name,
                value: chapter?.id,
              }))}
              className="basic-multi-select"
              classNamePrefix="select"
              closeMenuOnSelect={false}
              placeholder="Select Chapter"
            />
          </div>
        </Col>
        <Col xs="auto">
          <SaveButton type="button" content="Search" onClick={handleSearch} />
        </Col>
        {showResetButton && (
          <Col xs="auto">
            <SaveButton
              type="button"
              content="Reset"
              onClick={handleResetSearch}
              color="light"
            />
          </Col>
        )}
      </Row>
      <Row className="mt-4">
        <Col>
          <Table
            data={placesWithChapters?.data}
            columns={placesWithChaptersListColumns()}
            paginationData={{
              current_page: placesWithChapters?.current_page,
              last_page: placesWithChapters?.last_page,
              total_items: placesWithChapters?.total,
              items_per_page: placesWithChapters?.per_page,
              from: placesWithChapters?.from,
              to: placesWithChapters?.to,
              first_page: 1,
            }}
            onPageChange={handlePageChange}
            onTableSort={handleSort}
          />
        </Col>
      </Row>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  placesWithChapters: state.PlacesList.placesWithChapters,
  chapters: state.PlacesList.chapters,
  vendorId: state.Login.vendorId,
})

const mapDispatchToProps = dispatch => ({
  getPlacesWithChapters: values => dispatch(getPlacesWithChapters(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PlacesWithChaptersTab)
